import Dynamic from './Pages/Dynamic';
import { useDynamicSystem } from './hooks/useDynamicSystem';

import { Icon, } from '@iconify/react';
import './App.css';
import './index.css';
import './old.css';
import 'react-confirm-alert/src/react-confirm-alert.css';


function App() {

const { isReady, isUpdating } = useDynamicSystem();

  /* 🌟 Watch isUpdating and show/dismiss the toast!
  useEffect(() => {
    if (isUpdating) {
      // Show the loading toast. 
      // We give it a hardcoded ID so we can easily target it later.
      toast.loading('جاري التحقق من التحديثات...', { id: 'system-update-toast' });
    } else {
      // When isUpdating becomes false, dismiss that exact toast.
      toast.dismiss('system-update-toast');
      
      // OPTIONAL: If you want to show a success message instead of just disappearing:
      // toast.success('النظام محدث!', { id: 'system-update-toast', duration: 1000 });
    }
  }, [isUpdating]);
*/
  if (!isReady) {
    return (
      <div style={{ fontFamily: 'AlmaraiBold' }} dir='rtl' className="w-full h-screen flex flex-col items-center justify-center bg-bg-primary text-brand-primary">
         <Icon icon="solar:server-square-line-duotone" className="text-6xl animate-pulse mb-4" />
         <p className="font-bold text-lg">  جاري تحميل بيئة النظام...  </p>
        {/* <Toaster toastOptions={{ duration: 2000 }} />*/}
      </div>
     
    );
  }

 /*if (!isReady) {
    return (
      <div dir="rtl" className="w-full h-screen flex flex-col justify-center items-center bg-bg-primary text-brand-primary">
         <h1 className="font-bold text-lg animate-pulse">جاري تحميل بيئة النظام...</h1>
      </div>
    );
  }
*/

  return (
   <>
      {/* Start the entire app by calling the layout string from the DB! */}
      <Dynamic id="AppLayout" />
    </>
  );
}

export default App;